export const WIDGET_ID_HEADER = "X-WIDGET-ID";
export const STORE_URL_HEADER = "X-SHOPIFY-STORE-URL";
